module.exports = __webpack_public_path__ + "static/media/wilder-mind.689fa266.jpg";